import "./about.css";
import React from "react";

const About = () => {
  return (
    <div id="about-wrapper">
      <div id="about">
        <h1>Hey there! I'm Tyler Methot.</h1>
        <div id="intro-wrapper">
          <p class="intro">
            I'm on the cusp of earning my bachelor's degree in Physics with a
            minor in Computing from the University of Waterloo. My passion lies
            at the intersection of the abstract world of physics and the dynamic
            realm of web development.
          </p>
          <p class="intro">
            While I spent the last 7 years coding mostly in Python, C and C++,
            in my final semester, I've delved into the exciting realms of React
            and JavaScript, eager to bring a fresh perspective to the digital
            landscape. I find joy in the logic of code, the creativity in
            design, and the seamless fusion of the two in web development.
          </p>
          <p class="intro">
            Beyond the classroom, I've worn the hat of a tutor and teaching
            assistant, guiding aspiring minds through the intricate mazes of
            computer science, science, and math. The joy of helping others
            understand and excel in these subjects has been both rewarding and
            illuminating.
          </p>
          <p class="intro">
            What sets me apart is not just the knowledge I've acquired but the
            genuine enthusiasm I bring to programming. It's not just about
            writing lines of code; it's about creating digital experiences that
            resonate. I'm on the lookout for opportunities to turn this passion
            into impactful web development work. Let's build something amazing
            together!
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
